import { render, staticRenderFns } from "./CotPropostaAccessoEditPage.vue?vue&type=template&id=1bf26941"
import script from "./CotPropostaAccessoEditPage.vue?vue&type=script&lang=js"
export * from "./CotPropostaAccessoEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports